import { PAYMENT_STATES } from '@/utils/constants'
import { useCallback } from 'react'

const getModalCopy = (modalState, canClose) => {
  const isError = modalState === PAYMENT_STATES.PAYMENT_ERROR
  const isWaiting = modalState === PAYMENT_STATES.WAITING_FOR_PAYMENT

  return {
    title: isError ? 'Ops qualcosa è andato storto' : '',
    body: isError
      ? 'Si è verificato un errore durante il pagamento, ritenta.'
      : isWaiting && !canClose
        ? 'Stiamo elaborando il pagamento. Non chiudere questa finestra.'
        : 'Stiamo elaborando il pagamento, attendi...',
    ...(canClose ? { cta: isError ? 'Chiudi' : 'Annulla' } : {}),
  }
}

export const usePaymentModal = ({
  paymentState,
  setPaymentState,
  modalErrorIsOpen,
  setModalErrorIsOpen,
  isWindowActive = false,
  isProcessing = false,
  onRetry,
}) => {
  const handleModalClose = useCallback(() => {
    if (isWindowActive || isProcessing) return

    setModalErrorIsOpen(false)
    setPaymentState((prev) => ({
      ...prev,
      state: PAYMENT_STATES.IDLE,
      method: '',
    }))
  }, [setModalErrorIsOpen, setPaymentState, isWindowActive, isProcessing])

  const canClose = !isWindowActive && !isProcessing
  const effectiveState =
    modalErrorIsOpen ||
    (isProcessing ? PAYMENT_STATES.WAITING_FOR_PAYMENT : false)

  const modalConfig = {
    isOpen:
      effectiveState === PAYMENT_STATES.PAYMENT_ERROR ||
      effectiveState === PAYMENT_STATES.WAITING_FOR_PAYMENT,
    isError: effectiveState === PAYMENT_STATES.PAYMENT_ERROR,
    isLoading: effectiveState === PAYMENT_STATES.WAITING_FOR_PAYMENT,
    onClose: canClose ? handleModalClose : undefined,
    copy: getModalCopy(effectiveState, canClose),
    canClose,
    onRetry,
  }

  return {
    modalConfig,
    handleModalClose,
  }
}

export default usePaymentModal
